import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { portal } from '@/lib/api';

export default function MagicVerifyPage() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [msg, setMsg] = React.useState('Signing you in…');

  React.useEffect(() => {
    const token = params.get('token');
    const pay = params.get('pay');  // optional invoice_id to auto-pay after sign-in
    const next = params.get('next'); // optional deep-link target (e.g. /portal/esign/<id>)
    if (!token) { setMsg('Missing magic token. Please request a new sign-in link.'); return; }
    portal.verifyMagic(token)
      .then(() => {
        // If the email deep-linked to a specific invoice, jump straight into
        // the Invoices tab with `pay=<id>` so the Portal page auto-launches
        // Stripe checkout on mount.
        let target = '/portal';
        if (pay) target = `/portal?tab=invoices&pay=${encodeURIComponent(pay)}`;
        else if (next && next.startsWith('/portal/esign/')) {
          const esignId = next.replace('/portal/esign/', '');
          target = `/portal?tab=esign&sign=${encodeURIComponent(esignId)}`;
        }
        nav(target, { replace: true });
      })
      .catch((e) => setMsg(e?.response?.data?.detail || 'Magic link is invalid or has expired.'));
  }, [params, nav]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F7FA]">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-[#2ECC9A]" />
        <div className="text-sm text-slate-600">{msg}</div>
      </div>
    </div>
  );
}
